import { jsx as i, jsxs as a } from "react/jsx-runtime";
import { useState as $ } from "react";
import { Spacer as A } from "../Spacer/Spacer.mjs";
import { AnalyticsTagBuilder as b } from "@dai-team/analytics-library";
import v from "xss";
const D = (l) => {
  const {
    className: c,
    children: r,
    message: n,
    analytics: d,
    psnAnalytics: m,
    type: s,
    dismissable: e,
    componentSpacing: f,
    handleCloseNotification: o,
    testId: t
  } = l, u = s == "alert" ? "alert" : "status", N = new b().setDefaultName("Notification").setAnalyticsName(d).setPsnAnalytics(m), [p, h] = $(!1), y = (g) => {
    g.preventDefault(), h(!0), o && o(!0);
  };
  return p ? null : /* @__PURE__ */ i(A, { spacing: f, children: /* @__PURE__ */ i(
    "section",
    {
      className: `${c ?? ""}`,
      "data-testid": t ? `${t}` : null,
      children: /* @__PURE__ */ i(
        "div",
        {
          className: [
            "Notification",
            e && "Notification--dismissable",
            "Notification--withIcon",
            `Notification--${s}`
          ].filter(Boolean).join(" "),
          role: u,
          "data-testid": t ? `${t}-type` : null,
          children: /* @__PURE__ */ a("div", { className: "Notification-content", children: [
            /* @__PURE__ */ i(
              "div",
              {
                className: e ? "u-marginRight8" : "",
                "data-testid": t ? `${t}-message` : null,
                children: /* @__PURE__ */ a(
                  "div",
                  {
                    className: "Notification-message Content u-inline",
                    "data-testid": t ? `${t}-content` : null,
                    children: [
                      n && /* @__PURE__ */ i("span", { dangerouslySetInnerHTML: { __html: v(n) } }),
                      r
                    ]
                  }
                )
              }
            ),
            e && /* @__PURE__ */ a(
              "button",
              {
                className: "Notification-close Button Button--icon",
                onClick: y,
                ...N.dataAnalyticAttribute("close"),
                "data-testid": t ? `${t}-close` : null,
                children: [
                  /* @__PURE__ */ i("span", { className: "u-hiddenVisually", children: "Dismiss notification" }),
                  "close"
                ]
              }
            )
          ] })
        }
      )
    }
  ) });
};
export {
  D as Notification
};
//# sourceMappingURL=Notification.mjs.map
